import {ErrorHandler, Injectable} from "@angular/core";
import {ModalService} from "./modal.service";
import * as _ from "underscore";



@Injectable()
export class AppErrorHandler implements ErrorHandler {
    constructor(private modalSerice:ModalService) {
    }


    handleError(error:any) {
        if (_.has(error, "originalError")) {
            this.modalSerice.showError(error.originalError);
            return;
        }
        this.modalSerice.showError(error);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/error-handler.service.ts